import { Stack, Card, Text, Avatar } from "@mantine/core";
import { ReactComponent as HelpCenterIcon } from "../../../assets/icons/help-center.svg";
import { ReactComponent as LaptopIcon } from "../../../assets/icons/laptop.svg";
import TeamLeadPhoto from "../../../assets/images/team_lead.png";
import TeamManagerPhoto from "../../../assets/images/team_manager.png";
import CustomCard from "../../../components/Elements/Card/Card";
import SectionTitle from "../../../components/Elements/SectionTitle/SectionTitle";
import Title from "../../../components/Elements/Title/Title";

const HelpCenter: React.FC = () => {
  const team = [
    {
      id: 1,
      imageSrc: TeamLeadPhoto,
      contact: "00385 91 234 4567",
      role: "Team Lead",
    },
    {
      id: 2,
      imageSrc: TeamManagerPhoto,
      contact: "00385 91 234 4567",
      role: "Team Manager",
    },
  ];

  return (
    <Stack className="w-full" gap="0.5rem">
      <SectionTitle Icon={HelpCenterIcon} title="Help Center" />
      <CustomCard className="!cursor-default">
        <Card.Section className="p-4 border-b !border-[#2f2f31] bg-[#131316] gap-4 !flex flex-row items-center">
          <Avatar color="#030102" className="!bg-[#030102]">
            <LaptopIcon />
          </Avatar>
          <Stack gap="1">
            <Title title="IT Support" />
            <Text className="!text-neutral-50 !text-sm font-medium">
              00385 91 234 4567
            </Text>
          </Stack>
        </Card.Section>
      </CustomCard>
      <CustomCard className="mt-2 !cursor-default">
        {team.map((member) => (
          <Card.Section
            key={member.id}
            className="p-4 border-b !border-[#2f2f31] bg-[#131316] gap-4 !flex flex-row items-center"
          >
            <Avatar src={member.imageSrc} alt="team member photo" />
            <Stack gap="1">
              <Title title={member.role} />
              <Text className="!text-neutral-50 !text-sm font-medium">
                {member.contact}
              </Text>
            </Stack>
          </Card.Section>
        ))}
      </CustomCard>
    </Stack>
  );
};

export default HelpCenter;
